export const calculateDisplayEmail = (emailObject) => {
  const { email, workEmail, personalEmail } = emailObject ?? {};

  if (workEmail) return workEmail;
  if (personalEmail) return personalEmail;
  return email ?? '';
};

export const toGoalStakeholder = (employee, ownerType = 'OWNER') => ({
  id: employee?.id,
  displayName: employee?.displayName,
  profilePhoto: employee?.profilePhoto ?? employee?.profilePhotoSrc,
  designation: employee?.designation,
  employeeFunction: employee?.employeeFunction,
  email: employee?.email,
  workEmail: employee?.workEmail,
  personalEmail: employee?.personalEmail,
  ownerType,
});
